export default [
    {
		path: "/clinical",
		component: () => import("../views/Clinical/ListTreatmentSessions.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/clinical/treatmentsession/:treatmentsessionid?",
		component: () => import("../views/Clinical/TreatmentSession.vue"),
		meta: {
			hasmainmenu: true
		}
	},
	{
		path: "/clinical/patientfeedback/:treatmentsessionid",
		component: () => import("../views/Clinical/PatientFeedback.vue"),
	},
	{
		path: "/clinical/studentfeedback/:treatmentsessionid",
		component: () => import("../views/Clinical/StudentFeedback.vue"),
	},
	{
        path: "/clinical/treatmentsession/:treatmentsessionid/:path1?",
        component: () => import("../views/Clinical/TreatmentSession.vue"),
		meta: {
			hasmainmenu: true
		}
    },
]
